import React from 'react';

import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';

import { closeRemixModal } from './editor-commands/close-remix-modal';
import { openRemixModal } from './editor-commands/open-remix-modal';
import { startRemixThinking } from './editor-commands/start-remix-thinking';
import { stopRemixThinking } from './editor-commands/stop-remix-thinking';
import type { MalleableUiPlugin, MalleableUiSharedState } from './malleableUiPluginType';
import { remixButtonDecoration } from './pm-plugins/decorations-remix-button';
import { createMalleableUiPmPlugin, malleableUiPluginKey } from './pm-plugins/plugin-key';
import {
	createRemixThinkingPmPlugin,
	remixThinkingPluginKey,
} from './pm-plugins/remix-thinking-plugin';
import { PersistedSelectionHighlightStyles } from './ui/components/PersistedSelectionHighlightStyles';
import { RemixContent } from './ui/components/RemixContent';
import { getOverriddenFloatingToolbarConfig } from './ui/toolbars/overridden-floating-toolbar-config';
import { getSelectionToolbarComponents } from './ui/toolbars/toolbar-components';

const REMIX_BUTTON_DECORATION_TYPE = 'REMIX_BUTTON';

export const malleableUiPlugin: MalleableUiPlugin = ({ api, config }) => {
	api?.toolbar?.actions.registerComponents(getSelectionToolbarComponents(api));

	if (api && expValEquals('confluence_remix_icon_right_side', 'isEnabled', true)) {
		api.blockControls.actions.registerNodeDecoration({
			type: REMIX_BUTTON_DECORATION_TYPE,
			create: (params) => remixButtonDecoration({ ...params, api }),
		});
	}

	return {
		name: 'malleableUi',

		pmPlugins() {
			return [
				{
					name: 'malleableUi',
					plugin: ({ dispatch }) => createMalleableUiPmPlugin(dispatch),
				},
				{
					name: 'remixThinking',
					plugin: ({ dispatch }) => createRemixThinkingPmPlugin(dispatch),
				},
			];
		},

		getSharedState(editorState): MalleableUiSharedState | undefined {
			if (!editorState) {
				return undefined;
			}
			const malleableUiState = malleableUiPluginKey.getState(editorState);
			const remixThinkingState = remixThinkingPluginKey.getState(editorState);
			if (!malleableUiState || !remixThinkingState) {
				return undefined;
			}
			return {
				...malleableUiState,
				...remixThinkingState,
			};
		},

		commands: {
			openRemixModal,
			closeRemixModal,
			startRemixThinking,
			stopRemixThinking,
		},

		contentComponent: () => {
			return (
				<>
					<PersistedSelectionHighlightStyles />
					<RemixContent api={api} config={config} />
				</>
			);
		},

		pluginsOptions: {
			floatingToolbar: getOverriddenFloatingToolbarConfig(api),
		},
	};
};
